module.exports = __webpack_public_path__ + "static/media/home-bottom-content-default.92982945.jpg";